import {ENV} from '@/constants/EnvConstants';

export function createPaymentUrl({
  paymentLinkId,
}: {
  paymentLinkId?: string;
}): string {
  if (!paymentLinkId) return '';
  let base = (ENV.VITE_DOMAIN ?? '').replace(/\/$/, '');
  if (base && !/^https?:\/\//i.test(base)) {
    base = `https://${base}`;
  }
  return base ? `${base}/payment-link/v2/${paymentLinkId}` : '';
}
